import { apiClient } from './client';
import type { UserProfile, UserProgress, Achievement, UserSettings } from '@/types/user.types';

export interface MigrationRequest {
  profile: {
    userId: string;
    username?: string;
    xp: number;
    level: number;
    createdAt: string;
    lastActive: string;
  };
  progress: {
    tutorialProgress: Array<{
      levelId: string;
      completed: boolean;
      stars: 0 | 1 | 2 | 3;
      attempts: number;
      completedAt?: string;
    }>;
    challengeProgress: Array<{
      challengeId: string;
      completed: boolean;
      bestScore: number;
      bestTime: number;
      attempts: number;
      completedAt?: string;
    }>;
    escapeRoomProgress: Array<{
      roomId: string;
      completed: boolean;
      bestTime: number;
      puzzlesCompleted: number;
      completedAt?: string;
    }>;
    sandboxSessions: Array<{
      sessionId: string;
      name: string;
      templateId: string;
      createdAt: string;
      modifiedAt: string;
    }>;
  };
  achievements: Array<{
    achievementId: string;
    name: string;
    description: string;
    icon: string;
    unlockedAt: string;
    rarity: 'common' | 'rare' | 'epic' | 'legendary';
  }>;
  settings: {
    theme: 'dark' | 'light';
    soundEnabled: boolean;
    musicEnabled: boolean;
    animationsEnabled: boolean;
  };
}

export interface MigrationResponse {
  success: boolean;
  message: string;
  summary: {
    profile: boolean;
    settings: boolean;
    tutorialProgress: number;
    challengeProgress: number;
    escapeRoomProgress: number;
    achievements: number;
  };
  migratedAt: string;
}

export const migrationApi = {
  async migrateData(data: MigrationRequest): Promise<MigrationResponse> {
    return apiClient.post('/migration', data);
  },
};
